import React, { useState } from "react";
import { Button, NotificationBlock } from "uxp/components";
import { IContextProvider } from "../../../uxp";
import { IPropertyEditorProps, IUIPropertyDefinition } from "../common";
import { Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertySubTitle, PropertyTitle } from "./common";
import { IQueryConditionGroup, QueryBuilderModal, evaluateConditions } from "../query-builder/QueryBuilder";
import { $L } from '../../../localize';

type IVisibilityPropertyProps = IQueryConditionGroup

interface IVisibilityPropertyEditorProps {
    editorProps: IPropertyEditorProps<IVisibilityPropertyProps>,
    uxpContext: IContextProvider,
    contextData: any,
    title?: string
}

const VisibilityPropertyEditor: React.FunctionComponent<IVisibilityPropertyEditorProps> = ({ editorProps, uxpContext, contextData, title }) => {
    const [show, setShow] = useState(false)

    const count = (editorProps.uiProps?.Conditions?.length || 0) + (editorProps.uiProps?.Groups?.length || 0)
    const summary = count > 0
        ? $L('widgetdesigner.props.conditions', '$count condition(s)', { count })
        : $L('widgetdesigner.props.no-conditions', 'No conditions')

    return <PropertyContainer>
        <PropertyContainerTitle> {title || $L('widgetdesigner.props.visibility', 'Visibility')}</PropertyContainerTitle>

        <PropertyGroup>
            <Property>
                <PropertyTitle>{$L('widgetdesigner.props.field-visibility', 'Field Visibility')}</PropertyTitle>
                <PropertySubTitle> Field will only be visible if the conditions are true </PropertySubTitle>

                <NotificationBlock
                    variant="info"
                    mode="compact"
                    layout="bordered"
                    message={summary}
                    action={<Button
                        title={$L('widgetdesigner.props.edit', 'Edit')}
                        variant="secondary"
                        icon="fal pen"
                        iconPosition="right"
                        onClick={() => setShow(true)}
                    />}
                />

                <QueryBuilderModal
                    uxpContext={uxpContext}
                    uiProps={editorProps.parentUIProps}
                    designer={editorProps.designer}
                    contextData={contextData}
                    conditions={editorProps.uiProps}
                    onChangeConditions={(c) => {
                        editorProps.onChange(c)
                    }}
                    show={show}
                    onClose={() => setShow(false)}
                    hideTrigger
                />
            </Property>
        </PropertyGroup>
    </PropertyContainer>
}

export function VisibilityProperty(defaultProps: IVisibilityPropertyProps, title?: string): IUIPropertyDefinition<IVisibilityPropertyProps> {
    return {
        defaults: defaultProps,
        render: (props, uxpContext, contextData, containerId) => {
            return <VisibilityPropertyEditor
                editorProps={props}
                uxpContext={uxpContext}
                contextData={contextData}
                title={title}
            />
        }
    }
}
